import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { DataTestIds } from "@regrello/data-test-ids-api";
import { RegrelloButton } from "@regrello/ui-core";

export function VerificationContent({
  requestVerification,
  isLoading,
  email,
}: {
  requestVerification: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  email: string;
}) {
  return (
    <form className="flex flex-col mt-10 gap-10" onSubmit={requestVerification}>
      <h1 className="flex items-center text-4xl md:text-5xl">{t`Verify your email`}</h1>

      <p className="text-base">
        <Trans>We need to verify your email before showing your content.</Trans>
        <br />
        <Trans>
          If this is you, click the button below and we’ll send a secure link to <strong>{email}</strong>
        </Trans>
      </p>
      <p className="text-base">
        <strong>
          <Trans>If this is not your email, close this window.</Trans>
        </strong>
      </p>

      <RegrelloButton
        className="w-full p-3.5 capitalize"
        dataTestId={DataTestIds.VERIFY_DEVICE_BUTTON}
        intent="primary"
        loading={isLoading}
        type="submit"
      >
        {t`Send verification email`}
      </RegrelloButton>
    </form>
  );
}
